<div *ngIf="loadPopup">
 
 <abc-popup #userPopup
  fxLayout="column"
  fxLayoutAlign="center center"
  
  [width]="'50%'"
  [height]="'80%'"
  [title]="title"
  [showTitle]="true"
  [showCloseButton]="true"
  (onContentReady)="onPopupShown($event)"
  (onHiding)="closePopUp()"
  (onShowing)="this.showPopup()"
>
  <div  fxLayout="column"  fxLayoutAlign="space-between" fxLayoutGap="20px" fxFill>   
    <div  fxFlex="90" class="set-background">
      <abc-scroll-view width="100%" height="100%" [showScrollbar]="true">
            <app-user-settings #settings  [roleId]="roleId" ></app-user-settings>
      </abc-scroll-view>
          </div>
          <div fxFlex="10" fxLayout="row"  fxLayoutAlign="end center">
            <abc-button class="submit-permession"(click)="saveChanges()" [text]="dataService.res('Ubt-MeasureDetail-Save')">
            
          </abc-button>
          </div>
    
  </div>
</abc-popup>
</div>